import { ContentfulPhone } from "../../../../ContentfulTypes";
import { DeviceType } from "../../../../types";

const categorizePhone = (
  formattedPhone: ContentfulPhone,
  PhoneElement: React.JSX.Element,
  categories: {
    postpaidPhones: React.JSX.Element[];
    tablets: React.JSX.Element[];
    prepaidPhones: React.JSX.Element[];
},
) => {
  const deviceType = formattedPhone.deviceType.toLowerCase();
  if (deviceType === DeviceType.Phone) {
    categories.postpaidPhones.push(PhoneElement);
  } else if (deviceType === DeviceType.PrepaidPhone) {
    categories.prepaidPhones.push(PhoneElement);
  } else if (deviceType === DeviceType.Tablet) {
    categories.tablets.push(PhoneElement);
  }
};

export default categorizePhone;
